import ProductContainer from './Container';
import type { ProductCardProps } from './types';
import CardHead from './meta/card-head/card-head-horizontal';
import CardBody from './meta/card-body/card-body-horizontal';
import useTranslation from 'next-translate/useTranslation';
import ProductAddCart from './meta/add-cart';
import { twMerge } from 'tailwind-merge';
import React from 'react';
import EnchancedFavorite from './meta/enchanced-favorite';
import ProductLabel from './meta/label';

type ProductHorizontalProps = Partial<ProductCardProps> & {
  addCartBtn?: React.ReactNode;
  showFeatureLabel?: boolean;
  priceLineSlot?: React.ReactNode;
  [key: string]: any;
};

const ProductHorizontal: React.FC<ProductHorizontalProps> = props => {
  const { t } = useTranslation('common');
  const { data, className, children, showWeekly = true, showFeatureLabel = true, ...rest } = props;

  const renderAddCartBtn = () => {
    if (props.addCartBtn) {
      return props.addCartBtn;
    }
    if (data?.category === 'bundle' || data?.is_hotdish === 'Y') {
      return (
        <div className="absolute right-2 bottom-2 text-center bg-primary-2 rounded-500 text-reserved-true-white text-[13px] px-4 py-2 pointer-events-auto">
          <span>{t('btn_view')}</span>
        </div>
      );
    }
    return <ProductAddCart data={data} {...rest} cardType="horizontal" />;
  };

  return (
    <ProductContainer
      orientation="h"
      interactiveSlot={
        <>
          <div
            className={twMerge(
              'absolute left-2.5 top-2.5 w-[105px] h-[105px] pointer-events-none',
              props?.imageContainerCls
            )}>
            <EnchancedFavorite {...props} />
          </div>
          <div className="absolute right-0 top-0 w-full h-full pointer-events-none">{renderAddCartBtn()}</div>
        </>
      }
      {...props}>
      <div className={twMerge('h-full flex p-2.5 justify-start items-start relative box-border')}>
        <CardHead data={data} className="rounded-[15px]" {...rest} showFavorite={false}>
          {showFeatureLabel && (
            <ProductLabel
              {...props}
              labelProps={{ ...props.labelProps, onlyShowFeatureLabel: true }}
              labelHeadCls="absolute bottom-2 mb-0 right-2 z-[1] max-w-[90%] whitespace-nowrap text-ellipsis overflow-hidden"
            />
          )}
        </CardHead>
        <CardBody data={data} {...rest} cardType="horizontal" />
        {/* {renderAddCartBtn()} */}
        {children}
      </div>
    </ProductContainer>
  );
};

export default ProductHorizontal;
